/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The InlineResponse20014Data model module.
 * @module model/InlineResponse20014Data
 * @version 1.0.0
 */
export class InlineResponse20014Data {
  /**
   * Constructs a new <code>InlineResponse20014Data</code>.
   * @alias module:model/InlineResponse20014Data
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse20014Data</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20014Data} obj Optional instance to populate.
   * @return {module:model/InlineResponse20014Data} The populated <code>InlineResponse20014Data</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20014Data();
      if (data.hasOwnProperty('domainGroup'))
        obj.domainGroup = ApiClient.convertToType(data['domainGroup'], 'String');
      if (data.hasOwnProperty('count'))
        obj.count = ApiClient.convertToType(data['count'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} domainGroup
 */
InlineResponse20014Data.prototype.domainGroup = undefined;

/**
 * @member {Number} count
 */
InlineResponse20014Data.prototype.count = undefined;

